<template>
  <div style="height: 30vh;  margin: auto">
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        空间：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-cascader
          :options="spaceTree"
          @change="spaceChange"
          change-on-select="true"
          clearable
          collapse-tags
          filterable
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px; width: 80%"
          v-model="spaceId">
        </el-cascader>
      </el-col>
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
        <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
          设备：
        </el-col>
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <el-select
            @change="deviceChange"
            clearable
            collapse-tags
            placeholder="请选择"
            size="mini"
            style="padding-bottom: 5px;width: 80%"
            v-model="device">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in deviceList">
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
        <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
          测点：
        </el-col>
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <el-select
            :multiple="true"
            clearable
            collapse-tags
            placeholder="请选择"
            size="mini"
            style="padding-bottom: 5px;width: 80%"
            v-model="point">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in pointList">
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
        <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
          排序：
        </el-col>
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <el-input type="number" size="mini" v-model="ordinal" placeholder="请输入"
                    style="padding-bottom: 5px;width: 80%"></el-input>
        </el-col>
      </el-col>
    </el-col>
  </div>
</template>

<script>
import {listByDeviceId} from "@/network/device-measuring-point";
import {userDevice} from "@/network/device-info";
import lodash from "lodash";

export default {
  name: "alternate_device_modify",
  props: ["spaceTree", "form"],
  data() {
    return {
      id: '',
      point: '',
      spaceId: '',
      device: '',
      pointList: [],
      pointIdList: [],
      deviceList: [],
      ordinal: 0
    }
  },
  watch: {
    form(newVal) {
      this.form = newVal;
      this.setForm(lodash.cloneDeep(this.form));
    }
  },
  created() {

  },
  mounted() {
    this.setForm(this.form);
  },
  methods: {
    spaceChange(val) {
      if (val) {
        if (val.length > 0) {
          // 查询空间  若空间为逻辑空间，不允许选中
          this.spaceInfoId = val[val.length - 1];
          this.getDeviceList();
          this.device = '';
          this.point = '';
        }
      }
    },
    deviceChange() {
      this.getPointList();
      this.point = '';
    },
    getDeviceList() {
      let spaceInfo = Array.isArray(this.spaceInfoId) ? this.spaceInfoId[0] : this.spaceInfoId;
      userDevice(spaceInfo).then(res => {
        if (res.data) {
          this.deviceList = res.data
        }
      })
    },
    getPointList() {
      let device = Array.isArray(this.device) ? this.device[0] : this.device;
      listByDeviceId(device).then(res => {
        if (res.data) {
          this.pointList = res.data
        }
      });
    },
    setForm(form) {
      if (form === {} || form === null || form === "") {
        return;
      }
      this.id = form.id;
      this.spaceInfoId = form.spaceId;
      this.spaceId = form.spaceId;
      this.device = '';
      this.point = '';
      this.device = form.deviceId ? form.deviceId : '';
      this.point = form.alternateDevicePointList ? form.alternateDevicePointList.map(point => {
        return point.pointId
      }) : [];
      this.pointIdList = form.alternateDevicePointList;
      this.getDeviceList();
      this.getPointList();

    },
    getForm() {
      let spaceId = Array.isArray(this.spaceId) ? this.spaceId[this.spaceId.length - 1] : this.spaceId;
      let opt = {};
      opt = this.spaceTree.filter(item => item.id === spaceId)[0]
      let spaceName = opt ? opt.label : "";
      let selectDevice = this.deviceList.find((item) => {
        return item.id === this.device;
      });
      let pointLists = [];
      for( let pointId of this.point ) {
        let point = this.pointList.find((item) => {
          return pointId === item.id;
        });

        let editPoint = this.pointIdList ? this.pointIdList.filter(item => item.pointId === pointId)[0] : null;
        let editPointId = editPoint ? editPoint.id : null;
        pointLists.push({
          id: editPointId,
          pointId: point.id,
          pointName: point.name,
          pointCode: point.code,
          deviceId: this.device,
          deviceName: selectDevice.name,
          isShow: true
        })
      }
      console.log(this.point)
      return {
        id: this.id,
        spaceId: spaceId,
        spaceName: spaceName,
        deviceId: this.device,
        deviceName: selectDevice.name,
        ordinal: this.ordinal,
        alternateDevicePointList: pointLists,
      };
    }
  }
}
</script>

<style scoped>

</style>
